import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ColocacionComercialRoutingModule } from './colocacion-comercial-routing.module';
import { TendenciaComponent } from './tendencia/tendencia.component';
import { SharedModule } from '../../shared/shared.module';
import { PerfilComponent } from './perfil/perfil.component';
import { MetasComponent } from './metas/metas.component';
import { IndicadoresA1Component } from './indicadores-a1/indicadores-a1.component';
import { IndicadoresA3Component } from './indicadores-a3/indicadores-a3.component';


@NgModule({
  declarations: [
    TendenciaComponent,
    PerfilComponent,
    MetasComponent,
    IndicadoresA1Component,
    IndicadoresA3Component
  ],
  imports: [
    CommonModule,
    ColocacionComercialRoutingModule,
    SharedModule
  ]
})
export class ColocacionComercialModule { }
